import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { TextField, SelectField, TextAreaField, DateField } from './../../../components/fields';
import { required, isValidDateTime, errorMessages } from '../../../utilities/validation';
import Modal from '../../../components/modal';
import { InviteForm } from '../../../components/forms';
import WizardButtons from '../../../components/wizard/navigator/buttons';
import { getUsers, usersAreLoaded } from '../../../reducers/users';
import { RoleDefinitions } from '../../../utilities/roles';
import { sendInvite } from '../../../reducers/invites';
import { dateToFloatingString } from '../../../utilities/dateTime';

import './steps.css';

class PositionTheWorkStep extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: { open: false, type: undefined }
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        const { role, users, usersRole, getUsers } = this.props;
        if (!users || !usersAreLoaded(role, usersRole)) getUsers(role);
    }

    onOpen(type) {
        this.setState({ modal: { open: true, type } });
    }

    onClose() {
        this.setState({ modal: { open: false } });
    }

    render() {
        const { modal } = this.state;
        const {
            handleSubmit,
            cancel,
            selectedStartDate,
            selectedEndDate,
            submitting,
            role,
            userDetails,
            users,
            getUsers,
            sendInvite,
            changeField
        } = this.props;
        if (!users) {
            return null;
        }
        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <Field name="title" validate={required} component={TextField} placeholder={messages.title} />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="department" component={TextField} placeholder={messages.departmentOpt} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <Field
                                name="start_date"
                                selectedDate={selectedStartDate ? selectedStartDate : null}
                                validate={[required, isValidDateTime]}
                                component={DateField}
                                placeholder={messages.startDate}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field
                                name="end_date"
                                selectedDate={selectedEndDate ? selectedEndDate : null}
                                validate={isValidDateTime}
                                component={DateField}
                                placeholder={messages.endDateOptional}
                            />
                        </div>
                    </div>
                    <Field name="description" validate={required} component={TextAreaField} placeholder={messages.positionDescription} />
                    <div className="row">
                        <div className="col-xs-9 col-sm-10">
                            <Field
                                name="hm_id"
                                component={SelectField}
                                options={users.map(user => ({ value: user.id, label: `${user.first_name} ${user.last_name}` }))}
                                placeholder={messages.reportingTo}
                            />
                        </div>
                        <div className="col-xs-3 col-sm-2">
                            <button type="button" className="field-inline-button" onClick={() => this.onOpen('user')}>
                                <FormattedMessage {...messages.add} />
                            </button>
                        </div>
                    </div>

                    <WizardButtons disabled={submitting} cancel={{ action: cancel }} />
                </form>

                <Modal
                    open={modal.open}
                    onClose={this.onClose}
                    managedClose
                    size="col-sm-8 col-sm-offset-2 col-xs-12"
                    title={<FormattedMessage {...(modal.type === 'address' ? messages.addAddress : messages.addUser)} />}
                >
                    <div className="row">
                        <InviteForm
                            onSubmit={values =>
                                sendInvite({ ...values, clientId: userDetails.id }, role, () =>
                                    getUsers(role, result => {
                                        let newUser = result.find(u => u.email === values.email);
                                        changeField('position-wizard', 'hm_id', newUser.id);
                                        this.onClose();
                                    })
                                )
                            }
                            cancel={this.onClose}
                            tenantType={'client'}
                            initialValues={{ ref_id: role.id, ref_type: role.type, company_name: userDetails.name }}
                            availableRoles={[RoleDefinitions.Client, RoleDefinitions.ClientHiringManager]}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

PositionTheWorkStep = reduxForm({
    form: 'position-wizard',
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true,
    validate: values => {
        const errors = {};
        if (values.end_date && values.start_date && values.end_date < values.start_date) {
            errors.end_date = errorMessages.minValue(dateToFloatingString(values.start_date.add(1, 'days'), 'MM/DD/YYYY'));
        }
        return errors;
    }
})(PositionTheWorkStep);

const selector = formValueSelector('position-wizard');
const mapStateToProps = (state, props) => ({
    selectedStartDate: selector(state, 'start_date'),
    selectedEndDate: selector(state, 'end_date'),
    role: state.identity.role,
    userDetails: state.identity.details,
    users: state.users.list,
    usersRole: state.users.listRole,
    initialValues: {
        ...props.initialValues,
        ...props.position,
        ...(props.positionId && state.positions[props.positionId] ? state.positions[props.positionId] : {})
    }
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getUsers: getUsers,
            sendInvite: sendInvite,
            changeField: change
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PositionTheWorkStep);



// WEBPACK FOOTER //
// ./src/pages/position/steps/positionTheWork.jsx